import type { GetCategoryResponse } from '@vue-storefront/prestashop-api';
import { useSdk } from '~/sdk';

interface CategoryState {
  data: GetCategoryResponse['psdata'] | null;
  pending: boolean;
  error: Error | null;
}

export const useCategory = () => {
  const state = useState<CategoryState>(() => ({
    data: null,
    pending: false,
    error: null,
  }));

  async function fetchCategory() {
    state.value.pending = true;

    try {
      const { id } = useProductParams();
      const data = await useSdk().commerce.getCategory({ id });
      state.value.data = data;
    } catch (error) {
      useHandleError(error);
    } finally {
      state.value.pending = false;
    }
  }

  return {
    data: computed(() => state.value.data),
    pending: computed(() => state.value.pending),
    error: computed(() => state.value.error),
    fetchCategory,
  };
};
